import {
  getIsEventIframe,
  getIsPhotographerIframe,
  isWindowInIframe,
} from "../../v2_actions/nav";

import DesktopEventPageMapButton from "../DesktopEventPageMapButton";
import FilterActivity from "./FilterActivity";
import FilterCountry from "./FilterCountry";
import FilterDate from "./FilterDate";
import FilterGalleryEvent from "./FilterGalleryEvent";
import FilterPhotographer from "./FilterPhotographer";
import Link from "@mui/material/Link";
import { makeLogger } from "../../utils/o11y/logger";
import { useEventFiltersDispatcher } from "../hooks/useEventFiltersDispatcher";
import { useNavigate } from "react-router-dom";
import { useReduxStateReconcilation } from "../hooks/useReduxStateReconcilation";

const logger = makeLogger({
  enabled: true,
  label: "DesktopEventPageFilter",
  color: "pink",
});

export default function DesktopEventPageFilter({ gallery_event_name }) {
  useReduxStateReconcilation();
  const eventPageCtx = useEventFiltersDispatcher();
  const navigate = useNavigate();
  const isInIframe = isWindowInIframe();
  const isEventIframe = getIsEventIframe();
  const isPhotographerIframe = getIsPhotographerIframe();

  const handleClearFiltersClick = () => {
    logger.log("Reset all filter");
    const clearArg = {
      gallery_type: "event",
      activity_tags: undefined,
      shot_at_date_from: undefined,
      shot_at_date_to: undefined,
      _callSource: "DesktopEventPageFilter",
    };
    if (!isEventIframe) clearArg.gallery_event = undefined;
    if (!isPhotographerIframe) clearArg.photographers = undefined;

    eventPageCtx.updateAllListFilters(clearArg);

    if (isEventIframe) {
      navigate(`/customer/events/${gallery_event_name}`);
    } else {
      navigate(`/customer/events/`);
    }
  };

  const showCountry = !isInIframe;
  const showEvent = !isEventIframe;
  const showPhotographer = !isPhotographerIframe;

  logger.log({ isInIframe, showCountry, showEvent, showPhotographer });

  return (
    <>
      <h4 style={{ marginTop: 0, marginBottom: 8 }}>
        Filter Galleries:
        {!isInIframe && (
          <Link
            size="small"
            sx={{
              cursor: "pointer",
              ml: "24px",
              fontSize: "14px",
              fontWeight: "normal",
              ...(eventPageCtx.hasActiveFilters ? {} : { visibility: "hidden" }),
            }}
            onClick={handleClearFiltersClick}
          >
            clear all
          </Link>
        )}
      </h4>

      {showCountry && <FilterCountry />}
      {showEvent && <FilterGalleryEvent />}
      <FilterDate />
      <FilterActivity />
      {showPhotographer && <FilterPhotographer />}

      {/* Map widget now lives UNDER the Photographer filter */}
      {!isInIframe && (
        <div
          id="bf-map-preview-inline"
          style={{
            marginTop: 16,
            width: "100%",
            maxWidth: 260, // keeps the map card tidy in the sidebar
          }}
        >
          <DesktopEventPageMapButton />
        </div>
      )}
    </>
  );
}
